module.exports = __webpack_public_path__ + "img/demo6.eab99120.png";